import PropTypes from "prop-types";

/**
 * PropTypes for Content (Auth) component
 *
 * @property {string} title - Page title to display (required)
 * @property {ReactNode} children - Form or content to render (required)
 * @property {string} [logo] - Optional logo image URL
 */
export const authContentPropTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  logo: PropTypes.string,
};

/**
 * PropTypes for ContentRegister (Auth) component
 *
 * @property {string} title - Page title to display (required)
 * @property {ReactNode} children - Registration form or content to render (required)
 * @property {string} [logo] - Optional logo image URL
 */
export const authContentRegisterPropTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  logo: PropTypes.string,
};
